import React, { FC } from "react";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import Modal from 'react-modal'
import { useLocale } from "../../contexts/localeContext";
import { Form, Formik } from "formik";
import closeIcon from '../../images/close.svg';
import { ReportCard } from "./ReportCard";
import { Report } from "../../models/Report";
import { Button } from '../button/Button';

interface ReportProps {
    isOpen: boolean;
    onClose: () => void;
    saveReport: (values) => void;
    currentItem: Report
}

const ReportModal: FC<ReportProps> = ({ isOpen, onClose, saveReport, currentItem }) => {
    const { translate } = useLocale();

    return (
        <Modal
            isOpen={isOpen}
            ariaHideApp={false}
            overlayClassName="flex w-screen position-float-modal fixed top-0 left-0 h-screen bg-opacity-75 bg-white"
            className="bg-white border-none m-auto shadow select-none outline-none overflow-hidden" >
            <Formik
                enableReinitialize={true}
                initialValues={currentItem}
                onSubmit={saveReport}>
                <Form>
                    <div className={`w-full p-2 border-b flex flex-row items-center bg-sidemenu-focus text-white justify-between`}>
                        <div className="flex flex-row">
                            <p className="pl-3 font-bold font text-white">{translate.byKey(TranslationKeys.report)}</p>
                        </div>
                        <img src={closeIcon} onClick={onClose} className="cursor-pointer mr-2" />
                    </div>
                    <div className="pt-3 pl-8 pr-0" style={{ width: '400px' }} >
                        <ReportCard />
                    </div>
                    <div className="flex flex-row pb-3 pr-3 justify-end bg-white">
                        <div className="flex flex-row mt-4 mr-5">
                            <Button
                                variant="submit"
                                shape="pill"
                                id='submitBtn'
                                type='submit'>
                                {translate.byKey(TranslationKeys.confirm)}
                            </Button>
                        </div>
                    </div>
                </Form>
            </Formik>
        </Modal>
    )
}

export default ReportModal;
